<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">쇼핑몰 정품 인증 설정</p>
      <p class="mb-0 subtitle-1 font-weight-light">쇼핑몰에 정품 인증 페이지를 제공하여 고객이 인증 받을 수 있게 합니다.</p>
      <p class="mb-0 subtitle-1 font-weight-light">PC와 모바일 화면을 만들어 사용하며, 해당 페이지에 안내 문구 설정이 가능합니다.</p>
      <p class="mb-0 subtitle-1 font-weight-light">아래의 가이드에 따라 페이지를 생성하고 설정해주세요.</p>
      <p
        class="mb-0 subtitle-1 font-weight-light"
      >디자인 소스 삽입이 어려우신 분들께는 별도의 비용을 통해 대행하거나 커스텀 제작이 가능하오니 참고해주세요.</p>

      <v-tabs class="mt-10">
        <!--
          PC 화면 만들기 contents 영역
        -->
        <v-tab class="title">PC 화면 만들기</v-tab>
        <v-tab-item>
          <PcScreenMake></PcScreenMake>
        </v-tab-item>

        <!--
          모바일 화면 만들기 contents 영역
        -->
        <v-tab class="title">모바일 화면 만들기</v-tab>
        <v-tab-item>
          <MobileScreenMake></MobileScreenMake>
        </v-tab-item>

        <!--
          노출 문구 설정하기 contents 영역
        -->
        <v-tab class="title">노출 문구 설정하기</v-tab>
        <v-tab-item>
          <InfoTextSetting></InfoTextSetting>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>




<script>
import PcScreenMake from "@/components/authservice/setting/PcScreenMake.vue";
import MobileScreenMake from "@/components/authservice/setting/MobileScreenMake.vue";
import InfoTextSetting from "@/components/authservice/setting/InfoTextSetting.vue";

export default {
  components: {
    PcScreenMake,
    MobileScreenMake,
    InfoTextSetting
  }
};
</script>